import classnames from "classnames";
import { PopupMenu } from "../Menus/PopupMenu";
import { Spacer } from "../../../components/Layout/Layout";

import styles from "./TagSelector.module.css";

export interface Tag {
  title: string;
  value: string;
}

export interface TagListProps {
  tags: Tag[];
  maxPreviewOptions?: number;
  className?: string;
  style?: React.CSSProperties;
}

export const TagList = ({
  tags,
  maxPreviewOptions = 3,
  className,
  style,
}: TagListProps) => {
  const renderOptions = (startIndex: number, endIndex: number) =>
    tags.slice(startIndex, endIndex).map((option) => (
      <div
        key={`option_${option.value}`}
        className={classnames({
          [styles.tagOption]: true,
        })}
      >
        {option.title}
      </div>
    ));

  return (
    <span
      className={classnames({
        [styles.tagSelector]: true,
        ...(className ? { [className]: true } : {}),
      })}
      style={style}
    >
      {/* Visible options */}
      <span>{renderOptions(0, maxPreviewOptions)}</span>

      {/* Show more button with context menu */}
      {tags.length > maxPreviewOptions ? (
        <>
          <Spacer size={8} />
          <span>
            <PopupMenu variant="secondary">
              <div className={styles.tagContextMenuContainer}>
                {renderOptions(maxPreviewOptions, tags.length)}
              </div>
            </PopupMenu>
          </span>
        </>
      ) : null}
    </span>
  );
};
export default TagList;
